import React from "react";
import { Form, Input } from "antd";

export const CreateWorkForm = ({ form, onFinish }) => {
  return (
    <Form layout="vertical" form={form} onFinish={onFinish}>
      <Form.Item
        label="Код роботи"
        name="code"
        normalize={(value) => value?.trim()}
        rules={[{ required: true, message: "Введіть код роботи" }]}
      >
        <Input placeholder="Наприклад: A21.1" />
      </Form.Item>

      <Form.Item
        label="Назва роботи"
        name="title"
        rules={[{ required: true, message: "Введіть назву роботи" }]}
      >
        <Input placeholder="Наприклад: Монтаж кабелю" />
      </Form.Item>

      <Form.Item
        label="Одиниця виміру"
        name="unit"
        normalize={(value) => value?.trim().toLowerCase()}
        rules={[{ required: true, message: "Введіть одиницю виміру" }]}
      >
        <Input placeholder="шт / м / м² / год" />
      </Form.Item>
    </Form>
  );
};
